import type { GetStaticProps } from 'next'
import type { ComponentProps } from 'react'

import { getOurStudiesPage } from '@/graphql/OurStudies'

import { OurStudiesPage } from '@/components/pages/our-studies/OurStudiesPage'

type Props = ComponentProps<typeof OurStudiesPage>

export default OurStudiesPage

export const getStaticProps: GetStaticProps<Props> = async ({ preview }) => {
  const page = await getOurStudiesPage(preview)

  if (page) {
    return { props: { page: page } }
  }

  return {
    notFound: true,
  }
}
